import * as Yup from "yup";

export const validationSchema = Yup.object({
	name: Yup.string().min(1, "Минимум 1 символ").required("Поле обязательно"),
	source: Yup.string().min(1, "Минимум 1 символ").required("Поле обязательно"),
	noAnswerTimeout: Yup.number().min(0).required("Поле обязательно"),
	description: Yup.string(),
	dialTries: Yup.number().min(0).required("Поле обязательно"),
	maxChannels: Yup.number().min(0).required("Поле обязательно"),
	redialTimeout: Yup.number().min(0).required("Поле обязательно"),
	watchdog: Yup.number().min(0).required("Поле обязательно"),
	retryCauses: Yup.array().of(Yup.string()),
	autoload: Yup.boolean(),
	robotId: Yup.string(),
	endpointId: Yup.string(),
	timeintervals: Yup.array().of(Yup.string()),
	scheduler: Yup.array().of(
		Yup.object().shape({
			minutes: Yup.string(),
			hours: Yup.string(),
			date: Yup.string(),
			month: Yup.string(),
			dayOfWeek: Yup.string(),
		})
	),
});
